import { Component, OnInit } from '@angular/core';

import { ProfileInfoBoxComponent } from '../../profile-info-box.component';
import { ProfileInfoBoxBaseComponent } from '../profile-info-box-base.component';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormRowComponent } from '../../../../form/form-row/form-row.component';
import { FormFieldComponent } from '../../../../form/form-field/form-field.component';

@Component({
	selector: 'lb-profile-notes-info-box',
	standalone: true,
	imports: [FormsModule, ReactiveFormsModule, ProfileInfoBoxComponent, FormRowComponent, FormFieldComponent],
	templateUrl: './profile-notes-info-box.component.html',
	styleUrl: './profile-notes-info-box.component.scss'
})
export class ProfileNotesInfoBoxComponent extends ProfileInfoBoxBaseComponent implements OnInit {
	ngOnInit(): void {
		const form: FormGroup = this.form();
		const isDisabled = this.formDisabled() || false;

		form.addControl('bio', new FormControl({ value: this.profile().bio, disabled: isDisabled }));
	}
}
